import Report from '@/models/Report';
import ReportService from '@/services/ReportService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useReportsStore = defineStore('reports', {
  state: () => ({}),

  getters: {
    models: () => useRepo(Report),
  },

  actions: {
    async index(projectId: Id) {
      const [data, error] = await ReportService.index(projectId);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async show(reportId: Id) {
      const [data, error] = await ReportService.show(reportId);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async store(projectId: Id, form: ApiRequests['api.v1.reports.store']) {
      const [data, error] = await ReportService.store(projectId, form);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async update(reportId: Id, form: ApiRequests['api.v1.reports.update']) {
      const [data, error] = await ReportService.update(reportId, form);

      if(error) {
        throw error;
      }

      this.models.save(data.data);

      return data;
    },

    async generate(reportId: Id, form: ApiRequests['api.v1.reports.generate']) {
      const [data, error] = await ReportService.generate(reportId, form);

      if(error) {
        throw error;
      }

      return data;
    },

    async issue(reportId: Id, mediaUuid: string) {
      const [data, error] = await ReportService.issue(reportId, mediaUuid);

      if(error) {
        throw error;
      }

      return data;
    },
  },
});
